/**
 * standBaslik.js — which name leads a stand row / card on the staff stand pages
 *
 * Backlog #548 (Deniz 2026-10-30): a stand has three names — the code ("11.A10", already written
 * in the coloured StandThumbnail box), the stand's own name (`tabelaAdi`, the signage text, label
 * "Stand Adı" since #208) and the company (`firmaShortName`, long `firmaName`). The stand's own
 * name is what people look for in a row, so it takes the big slot and the company steps down to
 * the small line under it (the company-side Standlarım list has always done it this way).
 *
 * Older stands have no tabelaAdi: the big slot then keeps what it showed before — the company's
 * short name — and there is no second line to repeat it.
 *
 * Returns `{ birincil, ikincil, tabelaVar }`: big text, small text under it ("" when none), and
 * whether the big text is the stand's own name (the caller's tooltip differs).
 */
export function standBaslik(s) {
  const tabela = String(s?.tabelaAdi ?? "").trim();
  const firma = s?.firmaShortName || s?.firmaName || "";
  return {
    birincil: tabela || firma,
    ikincil: tabela ? firma : "",
    tabelaVar: tabela !== "",
  };
}
